export interface LocaleConfig {
  code: string;
  name: string;
  region: string;
  default: boolean;
  dateFormat: string;
  numberFormat: string;
  currency: string;
}

/** Site monolingue français : une seule entrée (routes / UI / SEO). */
export const supportedLocales: Record<string, LocaleConfig> = {
  fr: {
    code: 'fr-FR',
    name: 'Français',
    region: 'France',
    default: true,
    dateFormat: 'DD/MM/YYYY',
    numberFormat: 'fr-FR',
    currency: 'EUR'
  }
};

export const defaultLocale =
  Object.values(supportedLocales).find((locale) => locale.default)?.code || 'fr-FR';
